import { Dialog, DialogTitle, DialogActions, DialogContent, DialogProps } from '@mui/material';
import React from 'react';

export interface DialogPage {
    number: number;
    params?: string;
    available: number;
}

export interface ExtendedDialogProps extends DialogProps {
    disableEscapeKeyDown?: boolean;
}

const CustomDialog = (props: ExtendedDialogProps) => (
    <Dialog
        // {...props} must come first so the onClose handler overrides the default MUI behaviour.
        // Due to recent MUI changes, this order is required to prevent the dialog from closing when clicking the
        // backdrop.
        {...props}
        onClose={(event, reason) => {
            const { disableEscapeKeyDown } = props;
            if (disableEscapeKeyDown && reason === 'escapeKeyDown') return;
            if (reason !== 'backdropClick') {
                const { onClose } = props;
                onClose && onClose(event, reason);
            }
        }}
        disableEnforceFocus
    />
);

export { Dialog, CustomDialog, DialogTitle, DialogActions, DialogContent };
